import { render, staticRenderFns } from "./ProviderDetailsGeneralData.vue?vue&type=template&id=1c072235&"
import script from "./ProviderDetailsGeneralData.vue?vue&type=script&lang=js&"
export * from "./ProviderDetailsGeneralData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports